import BrandColors from '@pocketprep/ui-kit/pocketprep-export.module.scss'
import { instructorModule } from '@/store/instructor/module'
import { organizationModule } from '@/store/organization/module'
import { isPromise } from '@/utils'
import type { Study, Teach } from '@pocketprep/types'

const getCurrentOrgInstructorColors = (): { [key: string]: { textColor: string; fillColor: string } } => {
    const currentOrganization = organizationModule.getters.getCurrentOrganization()
    const instructors = !!currentOrganization
        && instructorModule.state.currentOrgInstructors[currentOrganization.objectId]?.value
    const colorObjs = [
        {
            textColor: '#750481',
            fillColor: '#F5C5FA',
        },
        {
            textColor: '#007223',
            fillColor: BrandColors.meadow || '',
        },
        {
            textColor: '#0845A4',
            fillColor: BrandColors.skyBlue || '',
        },
        {
            textColor: '#6D4705',
            fillColor: BrandColors.beachSand || '',
        },
        {
            textColor: BrandColors.pickledBluewood || '',
            fillColor: BrandColors.grayDivider || '',
        },
        {
            textColor: '#9D2E00',
            fillColor: '#FFDED2',
        },
        {
            textColor: '#B10000',
            fillColor: '#FFD7E1',
        },
        {
            textColor: '#005E61',
            fillColor: '#D4F1F4',
        },
        {
            textColor: '#A30067',
            fillColor: '#FFD8F4',
        },
    ]

    if (instructors && !(isPromise(instructors))) {
        return {
            default: colorObjs[0] as typeof colorObjs[0],
            ...Object.values(instructors).reduce((acc, instructor, index) => {
                acc[instructor.objectId] = colorObjs[index % colorObjs.length]
                    || { textColor: '#005E61', fillColor: '#D4F1F4' }
                return acc
            }, {} as { [key: string]: { textColor: string; fillColor: string } }),
        }
    } else {
        return { default: colorObjs[0] as typeof colorObjs[0] }
    }
}

const getCurrentOrgInstructorUsers = (): Record<string, Study.Class.UserJSON> | null => {
    const currentOrganization = organizationModule.getters.getCurrentOrganization()
    const currentOrgInstructorUsers = currentOrganization
        && instructorModule.state.currentOrgInstructorUsers[currentOrganization.objectId]?.value

    if (currentOrgInstructorUsers && !(isPromise(currentOrgInstructorUsers))) {
        return currentOrgInstructorUsers
    } else {
        return null
    }
}

const getCurrentOrgInstructors = (): Record<string, Teach.Class.OrgInstructorJSON> | null => {
    const currentOrganization = organizationModule.getters.getCurrentOrganization()
    const currentOrgInstructors = currentOrganization
        && instructorModule.state.currentOrgInstructors[currentOrganization.objectId]?.value

    if (currentOrgInstructors && !(isPromise(currentOrgInstructors))) {
        return currentOrgInstructors
    } else {
        return null
    }
}

const getCurrentOrgInstructor = () => {
    const currentOrgInstructors = getCurrentOrgInstructors()
    const currentOrgInstructorId = instructorModule.state.currentOrgInstructorId

    if (
        currentOrgInstructorId
        && currentOrgInstructors?.[currentOrgInstructorId]
    ) {
        return currentOrgInstructors[currentOrgInstructorId]
    } else {
        return null
    }
}

const getCurrentUserOrgInstructors = () => {
    const currentUserOrgInstructors = instructorModule.state.currentUserOrgInstructors.value

    if (!(isPromise(currentUserOrgInstructors))) {
        return currentUserOrgInstructors
    } else {
        return []
    }
}

const getCurrentUserPendingOrgInstructor = () => {
    const currentUserOrgInstructors = getCurrentUserOrgInstructors()
    return currentUserOrgInstructors.find(orgInstructor => orgInstructor.status === 'pending')
}

export default {
    getCurrentOrgInstructorColors,
    getCurrentOrgInstructorUsers,
    getCurrentOrgInstructors,
    getCurrentOrgInstructor,
    getCurrentUserOrgInstructors,
    getCurrentUserPendingOrgInstructor,
}
